<template>
  <div id="app">
    <div class="content">
      <h1 style="color: #eee; font-size: 50px;">朔州市旌普拉斯网络科技信息有限公司</h1>
    </div>
    <div class="icp">
      ©2025 朔州市旌普拉斯网络科技信息有限公司  
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">晋ICP备2024051469号</a>
    </div>
  </div>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-image: url('./assets/bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.icp {
  color: #ccc;
  font-size: 18px;
  font-weight: 500;
  padding: 50px 0;
}
.icp a {
  color: blue;
}
</style>
